import React from 'react';
import ProjectIdContextProvider from './ProjectIdContext/ProjectIdContextProvider';
import ProjectInfoContextProvider from './ProjectInfoContext/ProjectInfoContextProvider';

export default function ProjectContextsProvider({ children }: { children: React.ReactNode }) {
  return (
    <ProjectIdContextProvider>
      <ProjectInfoContextProvider>
        {children}
      </ProjectInfoContextProvider>
    </ProjectIdContextProvider>
  );
}
